// Construcción segura de embeds: solo proveedores permitidos (YouTube, Spotify).
// Jamás se inserta HTML arbitrario ni iframes recibidos como texto.

export function idYoutube(url) {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^(www|m)\./, "");
    let id = null;
    if (host === "youtu.be") {
      id = u.pathname.slice(1).split("/")[0];
    } else if (host === "youtube.com" || host === "youtube-nocookie.com") {
      if (u.pathname === "/watch") id = u.searchParams.get("v");
      const m = u.pathname.match(/^\/(embed|shorts|live)\/([^/?]+)/);
      if (m) id = m[2];
    }
    return id && /^[\w-]{11}$/.test(id) ? id : null;
  } catch {
    return null;
  }
}

export function urlEmbedSpotify(url) {
  try {
    const u = new URL(url);
    if (u.hostname !== "open.spotify.com") return null;
    const m = u.pathname.match(/^\/(playlist|album|track|artist|show|episode)\/(\w+)/);
    return m ? `https://open.spotify.com/embed/${m[1]}/${m[2]}` : null;
  } catch {
    return null;
  }
}

function fechaGoogle(iso) {
  return new Date(iso).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
}

export function urlGoogleCalendar(cal) {
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: cal.titulo,
    dates: `${fechaGoogle(cal.inicioISO)}/${fechaGoogle(cal.finISO)}`,
    details: cal.descripcion || "",
    location: cal.ubicacion || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function descargarIcs(cal) {
  const lineas = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Pro360//Invitaciones Digitales//ES",
    "BEGIN:VEVENT",
    `UID:${Date.now()}@pro360-invitaciones`,
    `DTSTAMP:${fechaGoogle(new Date().toISOString())}`,
    `DTSTART:${fechaGoogle(cal.inicioISO)}`,
    `DTEND:${fechaGoogle(cal.finISO)}`,
    `SUMMARY:${cal.titulo}`,
    `DESCRIPTION:${(cal.descripcion || "").replace(/\n/g, "\\n")}`,
    `LOCATION:${cal.ubicacion || ""}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ];
  const blob = new Blob([lineas.join("\r\n")], { type: "text/calendar;charset=utf-8" });
  const enlace = document.createElement("a");
  enlace.href = URL.createObjectURL(blob);
  enlace.download = "evento.ics";
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  URL.revokeObjectURL(enlace.href);
}
